<template>
    <div>
        <el-dialog v-model="dialogFormVisible" class="form-dialog" title="代客续费单" width="60%">
            <div v-if="timeError" style="margin-bottom: 15px">
                <el-alert :title="timeError" type="error" effect="dark" />
            </div>
            <el-form :model="form" label-width="auto" style="max-width: 600px">
                <el-form-item label="续费时长">
                    <el-input-number v-model="quantity" :min="minQuantity" @change="handleChange" />
                </el-form-item>
                <el-form-item label="请选择套餐">
                    <el-radio-group v-model="onPackage" name="package_id" @change="packageChange">
                        <template v-for="(item, index) in packagePrice" :key="index">
                            <el-radio-button
                                :label="index"
                            >
                                <text>{{ item.title }} (￥{{ item.price }})</text>
                            </el-radio-button>
                        </template>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择时间">
                    <div>
                        <el-tag>{{ startTime.date }}</el-tag>
                        <span class="sstime"> 到 </span>
                        <el-tag>{{ endTime.date }}</el-tag>
                    </div>
                </el-form-item>
                <el-form-item label="请选择优惠券">
                    <el-select
                        v-model="coupon"
                        name="user_id"
                        filterable
                        placeholder="请选择优惠券"
                        :multiple="false"
                        remote
                        reserve-keyword
                        remote-show-suffix
                        @change="couponChange"
                    >
                        <template v-for="(item, index) in couponList" :key="index">
                            <el-option
                                v-if="item.type != 3"
                                :label="`【${item.type_name}】 ${item.name}'【${item.discounts_price}元】 ${Utils.formatDate('Y-m-d H:i:s',item.end_time)}`"
                                :value="index"
                            />
                            <el-option
                                v-else
                                :label="`【${item.type_name}】 ${item.name}'【${item.use_type == 1 ? item.discount + '折' : item.discounts_price + '元'}】 ${Utils.formatDate('Y-m-d H:i:s',item.end_time)}`"
                                :value="index"
                            />
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="实付金额">
                    <el-input v-model="inputMoney" placeholder="请输入实付金额" />
                </el-form-item>
                <el-form-item label="可预定时段">
                    <div>
                        <template v-for="(item, index) in houseInfo.times" :key="index">
                            <el-tag v-if="item.is_show" style="margin-right: 5px" :type="item.is === 1 ? 'success' : 'danger'">
                                {{ item.h }}
                            </el-tag>
                        </template>
                    </div>
                </el-form-item>
                <el-form-item label="订单信息">
                    <el-descriptions direction="vertical" :column="4" :size="size" border>
                        <el-descriptions-item label="金额">￥{{ orderMoney }}元</el-descriptions-item>
                        <el-descriptions-item label="时长">{{ quantity }}小时</el-descriptions-item>
                        <el-descriptions-item label="原价">￥{{ yMoney }}元</el-descriptions-item>
                        <el-descriptions-item label="优惠">￥{{ discountsPrice }}元</el-descriptions-item>
                    </el-descriptions>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button type="primary" @click="onSubmit">提交订单</el-button>
                </el-form-item>

            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, computed } from 'vue'
    import { useOtherStore } from '@/store'
    import Cache from '@/utils/cache'
    import { Host } from '@/config/index'
    import { selectAjaxRemoteMethod } from '@/utils/function'
    import Utils from '@/utils/util'
    // import SelectAjax from '@/components/ui-form-page/items/selectajax'
    export default defineComponent({
        components: {
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()

            const StoreOther = useOtherStore()

            const dialogFormVisible = ref(false)
            const quantity = ref(1)
            const minQuantity = ref(1)
            const houseInfo = ref({})
            const packagePrice = ref([])
            const discountsPrice = ref(0)
            const orderInfo = ref()
            const userId = ref('')
            const onPackage = ref(null)
            const orderMoney = ref(null)
            const inputMoney = ref(null)
            const yMoney = ref(0)
            const add = (item) => {
                onPackage.value = null
                inputMoney.value = null
                coupon.value = null
                couponList.value = []

                let url = `${Host}store/shared/orders/continues`
                proxy.jiu.request(url, { house_id: item.id }, 'GET').then((res, rej) => {
                    dialogFormVisible.value = true
                    houseInfo.value = res.data.house
                    packagePrice.value = res.data.house.package_price
                    quantity.value = minQuantity.value = res.data.house.reordertime
                    orderInfo.value = res.data.order
                    userChange(res.data.order.user_id)
                    getTimeStart()
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const startTime = ref({})
            const endTime = ref({})
            const timeError = ref(false)
            const getTimeStart = () => {
                let time = orderInfo.value.end_time
                // 计算开始-结束时间
                let endtime_p = time + 3600 * quantity.value
                let startH = Utils.formatDate('H', time)
                let endH = Utils.formatDate('H', endtime_p)
                let startYmd = parseInt(Date.parse(Utils.formatDate('Y-m-d', time) + ' ' + startH + ':00:00') / 1000)
                let endYmd = parseInt(Date.parse(Utils.formatDate('Y-m-d', endtime_p) + ' ' + endH + ':00:00') / 1000)

                startTime.value = {
                    time: time,
                    date: Utils.formatDate('H:i', time),
                    h: startH
                }
                endTime.value = {
                    time: endtime_p,
                    date: Utils.formatDate('H:i', endtime_p),
                    h: endH
                }

                let _is = true
                let check = []
                for (let i in houseInfo.value.times) {
                    if (houseInfo.value.times[i].date >= startYmd && houseInfo.value.times[i].date <= endYmd) {
                        check.push(houseInfo.value.times[i])
                    }
                }
                if (check.length <= 0) {
                    _is = false
                } else {
                    for (let i in check) {
                        // 开始结束 可以有5分钟误差时间
                        if (check[i].date === startYmd && check[i].is !== 1) {
                            if (Math.abs(startYmd + 3600 - time) > 300) _is = false
                        } else if (check[i].date === endYmd && check[i].is !== 1) {
                            if (Math.abs(endYmd - endtime_p) > 300) _is = false
                        } else {
                            if (check[i].is !== 1) _is = false
                        }
                    }
                }
                if (!_is) {
                    _is = true
                    for (let i in check) {
                        if (check[i].oid > 0 && check[i].oid !== orderInfo.value.id) _is = false
                        if (check[i].oid <= 0 && check[i].is !== 1) _is = false
                    }
                }
                if (!_is) {
                    timeError.value = '您选择的时间有误，开始时间或结束时间，和其他订单时间有冲突，或选择了非服务时间段！请重新选择'
                    return false
                }
                getPrice()
            }

            const packageChange = (e) => {
                quantity.value = packagePrice.value[e].times
                onPackage.value = e
                getTimeStart()
            }

            const onSubmit = () => {
                if (timeError.value !== false) {
                    proxy.jiu.showError({ message: '您选择的时间或优惠券有误，请重新选择' })
                    return false
                }
                proxy.jiu.modal('温馨提示', '您确定都选择正确了吗！！', true, (e) => {
                    if (e) {
                        addOrder()
                    }
                }, 'warning')
            }
            const coupon = ref(null)
            const addOrder = () => {
                let obj = {
                    start_time: startTime.value.time,
                    end_time: endTime.value.time,
                    house_id: houseInfo.value.id,
                    order_id: orderInfo.value.id,
                    user_id: userId.value,
                    quantity: quantity.value,
                    money: inputMoney.value ? inputMoney.value : -1
                }

                if (coupon.value !== null) {
                    Object.assign(obj, {
                        coupon_id: couponList.value[coupon.value].id
                    })
                }

                let url = `${Host}store/shared/orders/continues`
                proxy.jiu.request(url, obj, 'POST').then((res, rej) => {
                    proxy.jiu.toast('完成下单')
                    context.emit('update:addorder', res.data)
                    dialogFormVisible.value = false
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const couponList = ref()
            const userChange = (e) => {
                userId.value = e
                let url = `${Host}store/shared/orders/get_coupon`
                proxy.jiu.request(url, { user_id: e }, 'POST').then((res, rej) => {
                    couponList.value = res.data
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const couponChange = (e) => {
                if (e === null) return false
                let sCoupon = couponList.value[e]
                if (sCoupon.type === false) return false
                if (sCoupon.type === 3) {
                    if (sCoupon.use_type === 2) {
                        if (parseFloat(sCoupon.full_price) > orderMoney.value) {
                            timeError.value = '当前订单金额小于满减卷最低限额' + sCoupon.full_price
                            return false
                        }
                    }
                } else {
                    // if (parseFloat(sCoupon.discounts_price) < yMoney.value) { timeError.value = '所选择团购券金额小于当前支付金额' return false }
                }
                coupon.value = e
                getPrice()
                timeError.value = false
            }
            const getPrice = () => {
                let time_p = quantity.value
                let ptp = 0
                packagePrice.value.forEach((item, index) => {
                    if (parseInt(item.times) <= quantity.value) {
                        onPackage.value = index
                    }
                })
                if (onPackage.value != null && onPackage.value >= 0) {
                    time_p = time_p - parseInt(packagePrice.value[onPackage.value].times)
                    ptp = parseFloat(packagePrice.value[onPackage.value].price)
                }
                if (time_p < 0) {
                    time_p = quantity.value
                    ptp = 0
                    onPackage.value = null
                }
                yMoney.value = parseInt(houseInfo.value.price * quantity.value * 100) / 100
                orderMoney.value = parseInt((time_p * houseInfo.value.price + ptp) * 100) / 100
                discountsPrice.value = parseInt((yMoney.value - orderMoney.value) * 100) / 100

                if (coupon.value !== null) {
                    let sCoupon = couponList.value[coupon.value]

                    if (sCoupon.type === 3) {
                        if (sCoupon.use_type === 2) {
                            // 满减
                            orderMoney.value = orderMoney.value - sCoupon.discounts_price
                        } else if (sCoupon.use_type === 1) {
                            // 折扣券
                            orderMoney.value = quantity.value * houseInfo.value.price * sCoupon.discount
                        } else if (sCoupon.use_type === 0) {
                            // 抵扣券
                            orderMoney.value = orderMoney.value - sCoupon.discounts_price
                        }
                        discountsPrice.value = yMoney.value - orderMoney.value
                    } else {
                        orderMoney.value = 0
                        discountsPrice.value = yMoney.value
                    }
                    orderMoney.value = parseInt(orderMoney.value * 100) / 100
                    discountsPrice.value = parseInt(discountsPrice.value * 100) / 100
                } else {
                    timeError.value = false
                }
            }
            const handleChange = (e) => {
                quantity.value = e
                getTimeStart()
            }
            return {
                quantity,
                minQuantity,
                handleChange,
                onPackage,
                orderMoney,
                yMoney,
                inputMoney,

                dialogFormVisible,
                houseInfo,
                couponList,
                coupon,

                packagePrice,

                packageChange,

                startTime,
                endTime,
                timeError,
                onSubmit,
                userChange,
                couponChange,
                discountsPrice,

                add,

                Utils
            }
        }
    })
</script>

<style scoped>

</style>
<script setup lang="ts">
</script>
